module.exports = __webpack_public_path__ + "static/media/pexels-bongkarn-thanyakij-3803219.4fff58ac.jpg";